import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import "./Footer.css";

const BG = "/images/hero/tools.png";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="footer">
      <div className="footer-bg" style={{ backgroundImage: `url(${BG})` }} />
      <div className="footer-overlay" />
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="GDM Installations" className="footer-logo-img" />
              <span>GDM</span>
            </Link>
          </div>
          <div className="footer-col">
            <h4>{t.footer.contact}</h4>
            <p>393 061 3734</p>
            <p>daniele.catalano@pec.fiscozen.it</p>
            <p>P.IVA: 09155970727</p>
            <p>Strada Torre di Brengola 1D - 70128 Bari (BA)</p>
          </div>
          <div className="footer-col">
            <h4>{t.footer.services}</h4>
            {t.footer.services_list.map((s) => (
              <Link key={s} to="">{s}</Link>
            ))}
          </div>
          <div className="footer-col">
            <h4>{t.footer.followUs}</h4>
            <a href="https://www.instagram.com/gdm_woodinstallation/" target= "blank" className="footer-social">
              <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="5"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
              Instagram
            </a>
          </div>
        </div>
        <div className="gold-divider" />
        <div className="footer-bottom">
          <p>{t.footer.rights}</p>
          <p className="footer-credit">
            Sito realizzato da{" "}
            <a href="https://webteamsolutions.it" target="_blank" rel="noopener noreferrer">WebTeam Solutions</a>
            {" "}·{" "}
            <a href="mailto:webteamsolutionswork@gmail.com">webteamsolutionswork@gmail.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
